'use client';

import { sendEvent } from '@/features/analytics/gtm/event';
import { getLoginStrategy } from '@/features/analytics/gtm/login-strategy';
import { useFoodangoUser } from '@/features/analytics/hooks/use-foodango-user';
import { useUser } from '@clerk/nextjs';
import { useEffect } from 'react';

export const PageViewHandler = () => {
  const { user } = useUser();
  const strategy = user?.primaryEmailAddress?.verification.strategy;

  const { data: foodangoUserQuery, isPending } = useFoodangoUser({
    email: user?.primaryEmailAddress?.emailAddress,
  });

  useEffect(() => {
    if (isPending) {
      return;
    }

    if (foodangoUserQuery && strategy) {
      sendEvent({
        event: 'user_data',
        value: {
          method: getLoginStrategy(strategy),
          user_id: foodangoUserQuery?.id,
          page: window.location.pathname,
        },
      });
    }
  }, [foodangoUserQuery, isPending, strategy]);

  return null;
};
